import { lighten, Link, List, ListItem, Stack, useTheme } from '@mui/material'

import { EMarketingClientPath } from '~/models/api'
import rem from '~/utils/ui'

function Nav() {
  const theme = useTheme()

  const columnStyle = {
    flex: 1,
    pt: 0,
  }

  const linkStyle = {
    color: lighten(theme.palette.tertiary1, 0.8),
    textTransform: 'uppercase',
    textDecoration: 'none',
    fontWeight: 600,
  }

  const col0Links = [
    {
      label: 'Pricing',
      path: EMarketingClientPath.pricing,
    },
  ]

  const col1Links = [
    {
      label: 'Support',
      path: EMarketingClientPath.supportAndContact,
    },
    {
      label: 'FAQ',
      path: EMarketingClientPath.faq,
    },
    {
      label: 'Referral Program',
      path: EMarketingClientPath.referralsAbout,
    },
  ]

  const col2Links = [
    {
      label: 'Privacy Policy',
      path: EMarketingClientPath.marketingPrivacyPolicy,
      target: '_blank',
    },
    {
      label: 'Terms and Conditions',
      path: EMarketingClientPath.marketingTermsOfUse,
      target: '_blank',
    },
  ]

  return (
    <Stack
      direction="row"
      justifyContent="center"
      spacing={4}
      useFlexGap
      sx={{
        flex: 3,
        flexDirection: { xxxs: 'column', sm: 'row' },
        gap: { xxxs: 0, sm: rem(16), lg: rem(32) },
      }}
    >
      <List sx={columnStyle}>
        {col0Links.map(({ label, path }) => (
          <ListItem key={path} sx={{ pl: 0 }}>
            <Link sx={linkStyle} href={path}>
              {label}
            </Link>
          </ListItem>
        ))}
      </List>
      <List sx={columnStyle}>
        {col1Links.map(({ label, path }) => (
          <ListItem key={path} sx={{ pl: 0 }}>
            <Link sx={linkStyle} href={path}>
              {label}
            </Link>
          </ListItem>
        ))}
      </List>
      <List sx={columnStyle}>
        {col2Links.map(({ label, path, target }) => (
          <ListItem key={path} sx={{ pl: 0 }}>
            <Link sx={linkStyle} href={path} target={target || '_self'}>
              {label}
            </Link>
          </ListItem>
        ))}
      </List>
    </Stack>
  )
}

export default Nav
